import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { strings } from "../../Translations/strings";
import { confirmEmail } from "./lib";
import "../Auth.scss";

const ConfirmEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    if (!token) {
      setStatus("error");
      return;
    }

    confirmEmail(token)
      .then(() => {
        setStatus("success");
      })
      .catch(() => {
        setStatus("error");
      });
  }, [token]);

  return (
    <div className="d-flex justify-content-center align-items-center login-container">
      <div className="nav-logo">
        <div className="empty-container"></div>
        <Link to="/">
          <img
            className="logo"
            src={require("../../Assets/logo.svg").default}
            alt="logo"
          />
        </Link>
        <div className="empty-container"></div>
      </div>
      <div className="contet-wrapper">
        <div
          className="form-container"
          style={{ textAlign: "center", padding: "40px 20px" }}
        >
          {status === "loading" && (
            <div className="spinner-border text-primary" role="status"></div>
          )}
          {status === "success" && (
            <>
              <h3 style={{ marginBottom: "12px" }}>
                {strings.confirm_email_success_title}
              </h3>
              <p style={{ color: "#666", marginBottom: "24px" }}>
                {strings.confirm_email_success_message}
              </p>
              <Button
                variant="primary"
                className="submit-form-register"
                onClick={() => navigate("/login")}
              >
                {strings.registration_confirm_go_to_login}
              </Button>
            </>
          )}
          {status === "error" && (
            <>
              <h3 style={{ marginBottom: "12px" }}>
                {strings.confirm_email_error_title}
              </h3>
              <p style={{ color: "#666", marginBottom: "24px" }}>
                {strings.confirm_email_error_message}
              </p>
              <Button
                variant="primary"
                className="submit-form-register"
                onClick={() => navigate("/register")}
              >
                {strings.confirm_email_go_to_register}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;
